export class BrowserMetaData {
  constructor() {
    this.ip = "";
    this.city = "";
    this.region = "";
    this.country = "";
    this.loc = "";
    this.org = "";

    this.postal = "";
    this.timezone = "";
    this.readme = "";
    this.os = "";
    this.browser = "";
    this.deviceType = "";
    this.orientation = "";
    // this.browser="";
  }

  ip: string;
  city: string;
  region: string;
  country: string;
  loc: string; // "lat,lon" as a string
  org: string;
  postal: string;
  timezone: string;
  readme: string;
  os: string;
  browser: string;
  deviceType: string;
  orientation: string;
}

export class DeviceInfo {
  userAgent: string;
  os: string;
  browser: string;
  device: string;
  os_version: string;
  browser_version: string;
  deviceType: string;
  orientation: string;
}
